<!--
 * @Author: Gaho
 * @Date: 2024-03-05 14:10:56
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-11 19:42:51
 * @Description: 
-->
<template>
    <div class="result-popup">
        <p>
            <b>{{ $t('hash') }}:</b>
            &nbsp; {{ data.hash }}
        </p>
        <p><b>{{ $t('random') }}:</b> &nbsp;{{ data?.random_seed || data?.randomSeed }}</p>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'resultPopup',
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
});
</script>

<style lang="scss" scoped>
.result-popup {
    background: #1f2329;
    border-radius: 5px 0 0 5px;
    border-right: 3px solid;
    box-sizing: border-box;
    opacity: 0;
    padding: 15px;
    position: absolute;
    right: calc(100% + 20px);
    top: -10px;
    transform: translate(-10px);
    transition: all 0.3s;
    visibility: hidden;
    width: 170px;
    z-index: 3;
    &::after {
        border: 6px solid transparent;
        border-left-color: currentColor;
        content: ' ';
        height: 0;
        left: calc(100% + 3px);
        margin-bottom: -6px;
        pointer-events: none;
        position: absolute;
        top: 9px;
        width: 0;
        @media (max-width: 1100px) {
            left: auto;
            right: calc(100% + 2px);
            transform: scaleX(-1); // 箭头转向 
            top: 8px;
        }
    }
    @media (max-width: 1100px) {
        transform: translate(125%);
        border-left: 3px solid;
        border-right: none;
    }
    p {
        line-height: 1.4;
        margin: 0 0 4px;
        overflow-wrap: break-word;
        word-break: break-word;
        hyphens: auto;
        color: #fff;
        &:last-child {
            margin-bottom: 0;
        }
    }
}
</style>
